import React, { createContext, useState, useEffect } from 'react';
  

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const userString = localStorage.getItem('user');
    return userString ? JSON.parse(userString) : null;
  });
  const [zipCode, setZipCode] = useState('');
  const [selectedResources, setSelectedResources] = useState([]);
  const [isHomePageView, setIsHomePageView] = useState(true); // View toggle state
  const [searchPagination, setSearchPagination] = useState(1); // Pagination state
  const [countyName, setCountyName] = useState(''); //Added by Amoy; manipulates user entered county

  // Load user data from localStorage on mount
  useEffect(() => {

    try {
      const storedUser = localStorage.getItem('user');
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      }
    } catch (error) {
      console.error("Failed to parse user data from localStorage:", error);
      localStorage.removeItem('user');
    }

    // Load zip code from localStorage on mount
    const storedZipCode = localStorage.getItem('zipCode');
    if (storedZipCode) {
      setZipCode(storedZipCode);
    }

    //Load county from LocalStorage on mount
    const storedCountyName = localStorage.getItem('countyName');
    if(storedCountyName){
      setCountyName(storedCountyName);
    }

    // Load search pagination from localStorage on mount
    const storedPagination = localStorage.getItem('searchPagination');
    if (storedPagination) {
      setSearchPagination(parseInt(storedPagination, 10)); // Parses string into a base 10 integer
    }
  }, []); // (Setup: The actual function, Dependenceies: values refered to in setup code)

  // Login and set user data
  const login = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData)); //Need to see if this string is necesarry for website functions
  };

  // Logout and clear user data
  const logout = () => {
    setUser(null);
    localStorage.removeItem('user');
    localStorage.removeItem('token')
    localStorage.removeItem('searchPagination'); // Clear pagination on logout
  };

  // Set zip code and persist it in localStorage
  const updateZipCode = (newZipCode) => {
    setZipCode(newZipCode);
    localStorage.setItem('zipCode', newZipCode);
  };

  // Set county name and persist it in localStorage
  const updateCountyName = (newCountyName) => {
    setCountyName(newCountyName);
    localStorage.setItem('countyName', newCountyName);
  };

  // Toggle between HomePage and AdminPage view for admins
  const toggleViewMode = () => {
    setIsHomePageView((prevView) => !prevView);
  };

  // Update pagination and persist in localStorage
  const updateSearchPagination = (page) => {
    setSearchPagination(page);
    localStorage.setItem('searchPagination', page);
  };

  const isLoggedIn = !!user; // returns true if there is a user, false if not. !! returns a boolean from a datatype
  const isAdmin = user?.role === 'admin'; // returns true if user's role is a string that is matches exactly

  // Function to add a resource to the selected list
  const addSelectedResource = (resource) => {
    setSelectedResources((prevResources) => [...prevResources, resource]);
  };

  // Function to remove a resource from the selected list
  const removeSelectedResource = (resourceId) => {
    setSelectedResources((prevResources) => 
      prevResources.filter(resource => resource._id !== resourceId)
    );
  };

  // Function to clear all selected resources (e.g., after PDF generation)
  const clearSelectedResources = () => {
    setSelectedResources([]);
  };


  const updateUserFavorites = (resourceId, isFavorited) => {
    const updatedFavorites = isFavorited
      ? [...(user?.favorites || []), resourceId]
      : (user?.favorites || []).filter(id => id !== resourceId);

    const updatedUser = { ...user, favorites: updatedFavorites };
    setUser(updatedUser);
    localStorage.setItem('user', JSON.stringify(updatedUser)); // Persist to localStorage
  };


  return (
    <AuthContext.Provider value={{
      user,
      login, 
      logout, 
      isLoggedIn, 
      isAdmin, 
      isHomePageView, 
      toggleViewMode, 
      zipCode, 
      updateZipCode,
      countyName,               //From Amoy
      updateCountyName,         //From Amoy
      setUser,
      selectedResources,
      addSelectedResource,
      removeSelectedResource,
      clearSelectedResources,
      searchPagination,         // Expose pagination state
      updateSearchPagination,    // Expose pagination update function
      updateUserFavorites
    }}>
      {children}
    </AuthContext.Provider>
  );
};
